export const trContent = {
  introduction: {
    content: [
      "1996'daki ilk çıkışından bu yana, Pokémon serisi dünya çapındaki oyuncuların kalbini kazandı ve en popüler eğlence markalarından biri haline geldi. Rastgele Pokémon Üreticimiz, her yaştan eğitmenler için tasarlandı; ister yeni Pokémonlar keşfetmek, dengeli bir takım oluşturmak, isterse Pokémon yolculuğunuzda sürprizlerin tadını çıkarmak için.",
      "İster bir sonraki yarışma için ilham arayan deneyimli bir oyuncu, ister Pokédex'inizi genişletmek isteyen gündelik bir oyuncu olun, bu rastgele Pokémon üretme aracı size geniş Pokémon dünyasını keşfetmek için eğlenceli ve interaktif bir yol sunacak."
    ]
  },
  howToUse: {
    content: [
      "Rastgele Pokémon seçicimizi kullanmak basit ve sezgisel. Mükemmel Pokémon takımınızı oluşturmaya başlamak için bu adımları izleyin:",
      {
        type: "orderedList",
        items: [
          { type: "text", content: "Pokémon sayısını seçin: Kaç Pokémon üretmek istediğinizi belirleyin (1-8)." },
          { type: "text", content: "Tür seçin: Ateş, Su, Elektrik vb. belirli Pokémon türlerini filtreleyin veya tüm türleri dahil etmek için \"Herhangi\" seçeneğini seçin." },
          { type: "text", content: "Nesil seçin: Birinciden sekizinci nesle kadar seçim yapın veya tüm nesillerden Pokémonları dahil etmek için \"Herhangi\" seçeneğini seçin." },
          { type: "text", content: "Nadirlik ayarlayın: Üretilecek Pokémonların nadirlik seviyesini belirleyin." },
          { type: "text", content: "\"Üret\" düğmesine tıklayın: Tercihlerinizi ayarladıktan sonra Pokémonları üretmek için düğmeye tıklayın." },
          { type: "text", content: "Sonuçları keşfedin: Her Pokémon hakkında temel istatistikler, yetenekler, türler ve daha fazlası dahil olmak üzere detaylı bilgileri görüntüleyin!" }
        ]
      },
      "Parametreleri istediğiniz zaman ayarlayabilir ve farklı Pokémon kombinasyonlarını keşfetmek için birkaç kez deneyebilirsiniz."
    ]
  },
  benefits: {
    content: [
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Tamamen ücretsiz: Rastgele Pokémon üreticimiz kullanımı tamamen ücretsizdir, gizli ücret veya abonelik gerektirmez." },
          { type: "text", content: "Özelleştirilebilir deneyim: Rastgele seçiminizi tür, nesil ve nadirliğe göre özelleştirin." },
          { type: "text", content: "Eğitim aracı: Çeşitli Pokémonların temel istatistiklerini, yeteneklerini ve türlerini öğrenin." },
          { type: "text", content: "Takım oluşturma asistanı: Gündelik veya rekabetçi savaşlar için hızlıca dengeli takımlar oluşturun." },
          { type: "text", content: "Meydan okuma oluşturucu: Rastgele üretilen Pokémonlarla kendinizi sınırlayarak benzersiz oyun meydan okumaları yaratın." },
          { type: "text", content: "Hesap gerektirmez: Kayıt olmadan veya kişisel bilgi vermeden aracı hemen kullanmaya başlayın." }
        ]
      }
    ]
  },
  history: {
    content: [
      "Pokémon serisi, 1996 yılında Satoshi Tajiri'nin Nintendo Game Boy için ilk oyunu yaratmasıyla başladı. Çocukluğundaki böcek koleksiyonu hobisinden ilham alan konsept, \"Pocket Monsters\" veya Pokémon olarak bilinen yaratıkları yakalama, eğitme ve onlarla savaşma etrafında şekillendi.",
      "Pokémon tarihindeki önemli dönüm noktaları şunları içerir:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "1996: Orijinal Pokémon Red ve Green oyunlarının Japonya'da piyasaya sürülmesi" },
          { type: "text", content: "1998: Pokémon Red ve Blue'nun uluslararası piyasaya sürülmesi" },
          { type: "text", content: "1999: Pokémon Kart Oyunu'nun küresel lansmanı" },
          { type: "text", content: "2000: 100 yeni Pokémon ekleyen Pokémon Gold ve Silver'ın piyasaya sürülmesi" },
          { type: "text", content: "2016: Seriyi mobil platformlara taşıyan Pokémon GO'nun piyasaya sürülmesi" },
          { type: "text", content: "2019: Nintendo Switch'te Pokémon Sword ve Shield'in piyasaya sürülmesi" }
        ]
      },
      "Bugün, sekiz nesil boyunca 900'den fazla farklı Pokémon ile seri; video oyunları, kart oyunları, anime dizileri, filmler, ürünler ve mobil uygulamaları kapsayacak şekilde genişledi ve tüm zamanların en karlı medya franchiselarından biri haline geldi."
    ]
  },
  popularPokemon: {
    content: [
      "Pokémon tarihinde, bazı Pokémonlar serinin ikonik sembolleri haline geldi:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Pikachu: Serinin Elektrik türü maskotu, şimşek şeklindeki kuyruğu ve kırmızı yanakları ile ünlü." },
          { type: "text", content: "Charizard: Hayranların favori Ateş/Uçan türü Pokémonu, ejderha benzeri görünümü ve gücüyle ünlü." },
          { type: "text", content: "Mewtwo: Mew'den genetik manipülasyon yoluyla yaratılan efsanevi Psişik türü Pokémon, muazzam gücüyle ünlü." },
          { type: "text", content: "Eevee: Vaporeon, Jolteon ve Flareon dahil olmak üzere çeşitli formlara evrimleşme benzersiz yeteneği nedeniyle sevilen." },
          { type: "text", content: "Gyarados: Zayıf bir Magikarp'tan evrimleşen güçlü Su/Uçan türü Pokémon." },
          { type: "text", content: "Lucario: Aura gücü ve rekabetçi savaşlardaki popülaritesiyle ünlü Dövüş/Çelik türü Pokémon." },
          { type: "text", content: "Greninja: Anime serisi aracılığıyla popülerlik kazanan Su/Karanlık türü ninja Pokémon." }
        ]
      },
      "Rastgele Pokémon üreticimiz size bu ikonik türleri ve aynı derecede ilgi çekici ancak daha az bilinen birçok türü keşfetme şansı veriyor."
    ]
  },
  popularGames: {
    content: [
      "Pokémon oyun serisi çeşitli platformlarda birçok popüler başlık yayınladı:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Pokémon Red, Blue ve Yellow: Game Boy'da efsaneyi başlatan orijinal oyunlar." },
          { type: "text", content: "Pokémon Gold, Silver ve Crystal: Johto bölgesini ve gündüz-gece sistemini tanıttı." },
          { type: "text", content: "Pokémon Ruby, Sapphire ve Emerald: Hoenn bölgesi ve çift savaşlarla oyun dünyasını genişletti." },
          { type: "text", content: "Pokémon Diamond, Pearl ve Platinum: Seriyi çevrimiçi özelliklerle Nintendo DS'ye taşıdı." },
          { type: "text", content: "Pokémon Black ve White: Hikayeye vurgu yaparak tamamen yeni bir Pokémon kadrosu tanıttı." },
          { type: "text", content: "Pokémon X ve Y: 3D modelleri ve Mega Evrim'i tanıttı." },
          { type: "text", content: "Pokémon Sun ve Moon: Salon sistemini Ada denemeleriyle yeniden düşündü." },
          { type: "text", content: "Pokémon GO: Küresel bir fenomen haline gelen artırılmış gerçeklik mobil oyunu." },
          { type: "text", content: "Pokémon Sword ve Shield: Seriyi Wild Area konseptiyle Nintendo Switch'e taşıdı." },
          { type: "text", content: "Pokémon Legends: Arceus: Serinin açık dünya türündeki ilk denemesi." }
        ]
      },
      "Her oyun yeni mekanikler ve Pokémonlar tanıttı, rastgele Pokémon üreticimiz aracılığıyla keşfedilebilecek Pokémon dünyasını genişletti."
    ]
  },
  tradingContests: {
    content: [
      "Pokémon takası başlangıçtan beri serinin temel bir özelliği oldu. Orijinal oyunlar özellikle arkadaşlar arasında Pokédex'i tamamlamak için Pokémon takasını teşvik etmek üzere çiftler halinde piyasaya sürüldü. Bu sosyal unsur Pokémon'un popülerliğinin yayılmasına yardımcı oldu ve bugün hala önemini koruyor.",
      "Takasın temel yönleri şunları içerir:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Yalnızca takas yoluyla elde edilebilen sürüme özel Pokémonlar" },
          { type: "text", content: "Machamp ve Gengar gibi bazı Pokémonlar yalnızca takas yoluyla evrimleşir" },
          { type: "text", content: "Modern oyunlarda Küresel Takas Sistemi (GTS) dünya çapında takas yapılmasına olanak tanır" },
          { type: "text", content: "Statü sembolü olarak nadir veya parlak Pokémon takası" }
        ]
      },
      "Üçüncü nesilde tanıtılan Pokémon Yarışmaları, Pokémonların savaş gücü yerine görünüm, performans ve çekicilik temelinde yarıştığı alternatif bir rekabet yolu sağladı. Bu yarışmalar şunları içerir:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Çeşitli yarışma kategorileri (Havalı, Güzel, Sevimli, Akıllı, Güçlü)" },
          { type: "text", content: "Yarışmalar için özel olarak tasarlanmış hamleler" },
          { type: "text", content: "Berry ve Poffin'ler aracılığıyla Pokémon durumunu yönetme" },
          { type: "text", content: "Ön görsel değerlendirme ve performans turları içeren çok aşamalı yarışmalar" }
        ]
      },
      "Rastgele Pokémon üreticimiz, yarışmalarda üstün performans gösteren veya değerli takas ortakları olan Pokémonları keşfetmenize yardımcı olabilir, Pokémon deneyiminize yeni bir boyut katabilir."
    ]
  },
  faq: {
    content: [
      {
        type: "faqList",
        items: [
          { 
            type: "faq",
            question: "Bu rastgele Pokémon üretici ücretsiz mi?",
            answer: "Evet, aracımız tamamen ücretsizdir, gizli ücret veya abonelik gerektirmez."
          },
          {
            type: "faq",
            question: "Pokémon verileri ne kadar doğru?",
            answer: "Tüm Pokémon verileri resmi PokéAPI'den gelir, doğruluk ve zamanında güncellemeler sağlar."
          },
          {
            type: "faq",
            question: "Belirli bir nesilden Pokémon üretebilir miyim?",
            answer: "Evet, birinciden sekizinciye kadar herhangi bir nesli seçebilir veya tüm nesilleri dahil etmek için \"Herhangi\" seçeneğini seçebilirsiniz."
          },
          {
            type: "faq",
            question: "Nadirlik filtresi nasıl çalışır?",
            answer: "Algoritmamız her Pokémon'a efsanevi/mitik statü, temel deneyim ve diğer faktörlere dayalı olarak 1-10 arası bir nadirlik değeri atar."
          },
          {
            type: "faq",
            question: "Üretilen Pokémonları kaydedebilir veya dışa aktarabilir miyim?",
            answer: "Şu anda sonuçların ekran görüntüsünü alabilirsiniz. Gelecek güncellemelerde kaydetme/dışa aktarma özelliği eklemeyi düşünüyoruz."
          },
          {
            type: "faq",
            question: "Rastgele Pokémon üretici mobil cihazları destekliyor mu?",
            answer: "Evet, üreticimiz tamamen duyarlı tasarımı destekler ve akıllı telefonlar, tabletler ve bilgisayarlarda kullanılabilir."
          }
        ]
      }
    ]
  },
  conclusion: {
    content: [
      "Rastgele Pokémon üreticimiz gündelik oyuncular ve profesyonel eğitmenler için sonsuz olasılıklar sunuyor. İster yeni favoriler keşfetmek, tematik bir takım oluşturmak, ister beklenmedik kombinasyonlarla kendinize meydan okumak isteyin, aracımız geniş Pokémon dünyasını keşfetmek için eğlenceli ve eğitici bir yol sağlıyor.",
      "Üreticiyi geliştirmek, yeni özellikler ve seçenekler eklemek için sürekli çalışıyoruz. Tercihlerinizi ayarlayın ve hangi Pokémonlarla karşılaşacağınızı görmek için şimdi \"Üret\" düğmesine tıklayın!",
      "Sonuçlarınızı arkadaşlarınız ve diğer eğitmenlerle paylaşın, Pokémon yolculuğunuzda rastgele Pokémon üreticiyi nasıl kullandığınızı bize bildirin. İyi keşifler!"
    ]
  }
}; 